import { useState, useEffect } from 'react';
import ru from 'date-fns/locale/ru';

import { capitalize } from 'utils/stringUtils';

export const useCustomHeaderPresenter = ({
  date,
  selected,
  changeMonth,
  changeYear,
  decreaseMonth,
  increaseMonth,
}) => {
  const [localDate, setLocalDate] = useState();
  const [isMonthChanged, setIsMonthChanged] = useState(false);

  const presenter = {
    get date() {
      return isMonthChanged ? date : selected || date;
    },

    get month() {
      return presenter.date?.getMonth();
    },

    get year() {
      return presenter.date?.getFullYear();
    },

    get title() {
      const month = capitalize(ru.localize.month(presenter.month));
      return `${month} ${presenter.year}`;
    },

    decreaseMonth() {
      decreaseMonth();
      setIsMonthChanged(true);
    },

    increaseMonth() {
      increaseMonth();
      setIsMonthChanged(true);
    },
  };

  useEffect(() => {
    if (selected && selected?.getTime() !== localDate?.getTime()) {
      setIsMonthChanged(false);
      setLocalDate(selected);
      changeMonth(presenter.month);
      changeYear(presenter.year);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, localDate, presenter.month, presenter.year]);

  return presenter;
};
